import React from 'react';
import ChatBotInterface from './ChatBotInterface';

const ChatBot = () => {

    return (
        <>
            <ChatBotInterface show={false} />
            <div className="hk-pg-body py-0" />
        </>
    )
}

export default ChatBot
